import { render } from "./InstantSearchComponent.vue?vue&type=template&id=79e80706"
import script from "./InstantSearchComponent.vue?vue&type=script&lang=js"
export * from "./InstantSearchComponent.vue?vue&type=script&lang=js"

import "./InstantSearchComponent.vue?vue&type=style&index=0&id=79e80706&lang=css"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__